export enum ProviderKey {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	MPI = 'MPI',
	// eslint-disable-next-line @typescript-eslint/naming-convention
	DXM = 'DXM',
}
